import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [7, null, null, null, 8, null, null, 9],
      fontWeight: "heading"
    }} mdxType="Text">Ahoy!</Text>
    <p>{`This is Galleon `}{`–`}{` a Gatsby theme built on top of `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/packages/@lekoarts/gatsby-theme-minimal-blog/"
      }}>{`gatsby-theme-minimal-blog`}</a>{` by `}<a parentName="p" {...{
        "href": "https://www.lekoarts.de/en"
      }}>{`LekoArts`}</a>{`.
Use this theme to build a gorgeous developer blog with support for Typescript, MDX, syntax-highlighted code blocks, and tags.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      